/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "./Experience.css";
import { BsPatchCheckFill } from "react-icons/bs";




import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import ProgressBar from "@ramonak/react-progress-bar";


const Experience = () => {

  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("https://portfolio-server-tau-liart.vercel.app/api/skills")
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      });
  },[]);


  const animation = { duration: 10000, easing: (t) => t }
  const [sliderRef] = useKeenSlider({
      loop: true,
      renderMode: "performance",
      mode: "free",
      breakpoints: {
          '(min-width: 820px)': {
              slides: {
                  perView: 8,
                  spacing: 5,
              },
          },
          '(max-width: 450px)': {
              loop: false,
              slides: {
                  perView: 3,
                  spacing: 2,
              },
          },
      },

      created(s) {
          s.moveToIdx(5, true, animation)
      },
      updated(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
          s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
  })






  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Skills</h2>


      {/* <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>CSS</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Javascript</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Typescript</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Tailwind</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>React</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Redux</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Next.js</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
          </div>
        </div>
        <div className="experience_backend">
          <h3>Backend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Node JS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>MongoDB</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>Mongoosh</h4>
                <small className="text-light">Experience</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icons"></BsPatchCheckFill>
              <div>
                <h4>MySQL</h4>
                <small className="text-light">basic</small>
              </div>
            </article>
          </div>
        </div>
      </div> */}




<div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 mx-auto mr-12 md:mx-[0%] lg:mx-[9%]">
        {data?.data?.map((skill, index) => (
          <div key={index} data-aos="fade-right" className="relative">
          <div className="w-48 h-48 ">
          <img 
            src={skill?.icon}
            className=" h-48 ml-3 mt-1 rounded p-4"
          />
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition duration-300 bg-black rounded-3xl">
            <p className="text-white text-lg font-bold">
              <div
                data-aos="fade-right"
                className="radial-progress mr-0 lg:mr-12 ml-5 md:ml-0 lg:ml-0 text-purple-500"
                style={{
                  "--value": skill.progress,
                  "--size": "8rem",
                  "--thickness": "5px"
                }}>
                <h1 className="text-xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
                  {skill.name}
                </h1>
                <p className="text-2xl mx-auto text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
                  {skill.progress}%
                </p>
              </div>
            </p>
          </div>
        </div>
        ))}
      </div>


   <section id="experience">
    
<div ref={sliderRef} className="keen-slider mt-10">
                {
                   data?.data?.map((skill, idx) => (
                        <div key={idx} className="keen-slider__slide number-slide1 py-2">
                            <div
                                className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                            >
                                <img src={skill.icon} className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                                <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                                    <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">{skill.name}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }














                <div className="keen-slider__slide number-slide1 py-2 ">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/YjqNmZL/html.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">HTML</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/SX276G7/css.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">CSS</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/jwqTzDd/bootstrap.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Bootstrap</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/mbC2t6w/tailwind.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Tailwind CSS</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/Z8vpXzB/js.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">JavaScript</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/V3Sdqt8/git.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Git</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/RPfXW1z/github-icon.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">GitHub</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/c19VQky/react.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">React.js</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/R6TQ7nR/node.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Node.js</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/80YCHX7/expressjs.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Express.js</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/h2fXhpg/mongo-db.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">MongoDB</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/frdCz7M/firebase.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Firebase</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/qCKCSLq/nextjs.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Next.js</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/vcHW0WY/redux.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Redux</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/t2DSkMg/jwt.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">JWT</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/b5bJ3yb/Rest-API-1.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">REST API</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/hWLqygn/figma.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Figma</p>
                        </div>
                    </div>
                </div>
                <div className="keen-slider__slide number-slide1 py-2">
                    <div
                        className="lg:mt-0 mt-2 bg-slate-600/30 ring-1 ring-myGreen/40 text-center backdrop-blur-sm rounded-2xl duration-200 hover:scale-105 hover:ring-myPurple mx-auto p-6 lg:w-[140px] w-[115px] relative group "
                    >
                        <img src="https://i.ibb.co/vX67w1M/Typescript-logo-2020-svg.png" className="lg:h-[80px] h-[65px] mx-auto" alt="" />
                        <div className="lg:w-[140px] w-[115px] mx-auto absolute bottom-0 left-0 transform translate-y-full opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                            <p className="font-semibold lg:text-xl sm:text-md lg:p-0 text-white">Typescript</p>
                        </div>
                    </div>
                </div>
            </div>
   </section>





{/* 
<div id="skills" className="w-[90%] mx-auto">
      <h2 className="text-center text-4xl font-bold m-5 p-5 border-b-4 border-gray-500 w-1/2 mx-auto">
        My Skills
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5 mt-5">
        {data?.data?.map((item) => (
          <div>
            <h2 className="text-2xl">{item.name}</h2>
            <ProgressBar
              className="progress"
              completed={item?.progress}
            ></ProgressBar>
          </div>
        ))}
      </div>
    </div> */}



    </section>
  );
};

export default Experience;
